export default __webpack_public_path__ + "static/media/featureImage3.702dc0ea.png";